import { ConfirmAuctionPaymentInput } from "@admin/pages/auctions-to-pay-manager/interfaces/payment.interface";
import { AuctionPaymentShippingDto } from "@admin/pages/awarded-auctions-manager/interfaces/awarded-auctions.interface";
import { ICharity } from "@admin/pages/charity-manager/interfaces/charity.interface";
import { IPromoter } from "@admin/pages/promoter-manager/interfaces/promoter.interface";
import { ISettings } from "@admin/pages/settings-manager/interfaces/settings.interface";
import { Insurance } from "@admin/pages/shipping-insurance-manager/interfaces/shipping-insurance.interface";
import { ShippingRateCountryDto, ShippingRateDto } from "@admin/pages/shipping-manager/interfaces/shipping.interface";
import { ISponsor } from "@admin/pages/sponsor-manager/interfaces/sponsor.interface";
import { Method } from "@core/enums/api.enum";
import { ArticleRequest } from "@core/interfaces/article-request.interface";
import { ICustomUrlDto } from "@core/interfaces/custom-url-dto.interface";
import { EmailRequestDto, ResetPasswordEmailDto } from "@core/interfaces/email.interface";
import { ISlideShowItem } from "@core/interfaces/islideshowitem";
import {
  IMessageDto,
  IMessageUpdateDto,
  IModerateMessageDto,
  IStartConversation,
} from "@core/interfaces/start-conversation.interface";
import { UsersNewsletterRegistered } from "@core/interfaces/usersNewsletterRegistered";
import { VerifyReCaptchaDto } from "@core/interfaces/verify-recaptcha-dto.interface";
import {
  Accessory,
  Auction,
  AuctionDto,
  AuctionPaymentAccessoryDto,
  AuctionPaymentsAddressDto,
  AuctionReserveDto,
  AuctionSellerPaymentDto,
  BidDto,
  CapturePaypalPaymentDto,
  CreatePaymentSessionDto,
  MakeOfferDto,
  PaymentGuidDto,
  ProposeNewPrice,
  ResponseOfferDto,
  StripePaymentIntentConfirmDto,
  UserAutoRebid,
} from '@memorabid/common';
import { DonationDto, MemoraEventSaveDto, NotificationStatusDto } from "@shared/interfaces/event.interface";
import { GetAllFilterPropertiesDto, IAuctionFilterDto } from "@shared/interfaces/search.interface";
import { IConfirmNotification } from 'src/app/account/interfaces/notification.interface';
import { ICampaign } from 'src/app/campaigns-manager/interfaces/campaign.interface';
import { IEntityData } from 'src/app/entities-manager/interfaces/entity.interface';
import {
  IUserActivationDto,
  IUserEventRegistrationDto,
  IUserLoginDto,
  IUserPwdResetDto,
  IUserRegistrationDto,
  UserResetPasswordWithCode,
} from 'src/app/login/interfaces/login.interfaces';
import { PageText } from 'src/app/pages-manager/interfaces/pages.interface';
import { Tag } from 'src/app/tags-manager/interfaces/tag.interface';
import { ITranslationDto } from 'src/app/translations-manager/interfaces/itranslationadmin.interface';
import { IUser } from 'src/app/users-manager/interfaces/user.interface';
import { IRequestOptions } from '../interfaces/api-request-options.interface';

export class ApiServiceHolder {
  static publicGeneric = {
    controller: 'publicGeneric',
    getGlobalSettings() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getglobalsettings`,
      };
    },
    getAllCountries() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getAllCountries`,
      };
    },
    getAllIdentificationCardTypes() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getAllIdentificationCardTypes`,
      };
    },
    getAllEntityTypes() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getAllEntityTypes`,
      };
    },
    getAllAddressType() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getAllAddressType`,
      };
    },
    getAllDetails() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getalldetails`,
      };
    },
    getPriceRange() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getpricerange`,
      };
    },
    getAllArticleCategories() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallarticlecategories`,
      };
    },
    GetAllEmailSubjects() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/GetAllEmailSubjects`,
      };
    },
    getSports(onlyUsed: boolean) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getsports`,
        parameters: { onlyUsed },
      };
    },
    getCompetitions(idSport: number, onlyUsed: boolean) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getcompetitions`,
        parameters: { idSport, onlyUsed },
      };
    },
    getTeams(idSport: number, onlyUsed: boolean) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getteams`,
        parameters: { idSport, onlyUsed },
      };
    },
    getAllPaymentTypes() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallpaymenttypes`,
      };
    },
    getAllDetailedPaymentTypes() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getalldetailedpaymenttypes`,
      };
    },
  };
  static email = {
    controller: 'email',
    sendContactFormEmail(emailRequest: EmailRequestDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/sendcontactformemail`,
        body: emailRequest,
      };
    },
    sendResetPasswordEmail(emailRequest: ResetPasswordEmailDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/sendresetpasswordemail`,
        body: emailRequest,
      };
    },
  sendMagicLoginEmail(emailRequest: { email: string; languageCode: string; redirectPath?: string }) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/sendmagicloginemail`,
        body: emailRequest,
      };
    },
    verifyReCaptcha(verifyReCaptcha: VerifyReCaptchaDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/verifyrecaptcha`,
        body: verifyReCaptcha,
      };
    },
  };
  static usersNewsletterRegistered = {
    controller: 'usersnewsletterregistered',
    getAll() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getall`,
      };
    },
    Insert(email: UsersNewsletterRegistered) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/insert`,
        body: email,
      };
    },
  };
  static accessory = {
    controller: 'accessory',
    getAll(idLanguage: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getall`,
        parameters: { idLanguage },
      };
    },
    getAllForCart(
      idLanguage: number,
      idCategory: number,
      idAuction: number,
      idSeller: number
    ) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallforcart`,
        parameters: { idLanguage, idCategory, idAuction, idSeller },
      };
    },
    save(body: Accessory): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/save`,
        body,
      };
    },
    getByPk(idAccessory: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getbypk`,
        parameters: { idAccessory },
      };
    },
    delete(idAccessory: number): IRequestOptions {
      return {
        method: Method.DELETE,
        relativeUrl: `${this.controller}/delete`,
        parameters: { idAccessory },
      };
    },
  };
  static entityData = {
    controller: 'entitydata',
    getAll() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getall`,
      };
    },
    getByPk(idEntity: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getbypk`,
        parameters: { idEntity },
      };
    },
    getBaseDataByPk(idEntity: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getbasedatabypk`,
        parameters: { idEntity },
      };
    },
    getAllKeyValue() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallkeyvalue`,
      };
    },
    getAllSellerKeyValue() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallsellerkeyvalue`,
      };
    },
    save(entity: IEntityData) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/save`,
        body: entity,
      };
    },
    delete(idEntity: number): IRequestOptions {
      return {
        method: Method.DELETE,
        relativeUrl: `${this.controller}/delete`,
        parameters: { idEntity },
      };
    },
    getAddresses(idEntity: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getaddresses`,
        parameters: { idEntity },
      };
    },
    hasSellerRequirements(idEntity: number): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/hassellerrequirements`,
        parameters: { idEntity },
      };
    },
  };
  static user = {
    controller: 'user',
    register(item: IUserRegistrationDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/register`,
        body: item,
      };
    },
    registerForEvent(item: IUserEventRegistrationDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/registerforevent`,
        body: item,
      };
    },
    activateUser(item: IUserActivationDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/activateuser`,
        body: item,
      };
    },
    authenticate(item: IUserLoginDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/authenticate`,
        body: item,
      };
    },
    logout() {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/logout`,
      };
    },
    ping() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/ping`,
      };
    },
    getAll() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getall`,
      };
    },
    getByUsername(username: string) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getbyusername`,
        parameters: { username },
      };
    },
    exists(username: string) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/exists`,
        parameters: { username },
      };
    },
    getAllUserProfiles() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallprofiles`,
      };
    },
    update(item: IUser) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/update`,
        body: item,
      };
    },
    resetPassword(item: IUserPwdResetDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/resetpassword`,
        body: item,
      };
    },
    resetPasswordWithCode(item: UserResetPasswordWithCode) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/resetpasswordwithcode`,
        body: item,
      };
    },
    magicLoginWithCode(requestCode: string) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/magicloginwithcode`,
        body: { requestCode },
      };
    },
  };
  static tag = {
    controller: 'tag',
    get(idTag: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/${idTag}`,
      };
    },
    getByDescription(description: string) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getbyslug/${description}`,
      };
    },
    getAllTagsWithInfo() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallwithinfo`,
      };
    },
    save(item: Tag) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/save`,
        body: item,
      };
    },
    delete(idTag: number) {
      return {
        method: Method.DELETE,
        relativeUrl: `${this.controller}/delete`,
        parameters: { idTag },
      };
    },
    getAllUsersByTag(idTag: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallusersbytag`,
        parameters: { idTag },
      };
    },
  };
  static auctionpaymentshipping = {
    controller: 'auctionpaymentshipping',
    getAll(idLanguage: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getall`,
        parameters: { idLanguage },
      };
    },
    save(body: AuctionPaymentShippingDto): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/save`,
        body,
      };
    },
  };
  static campaign = {
    controller: 'campaign',
    getAll(onlyActive: boolean, idLanguage: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getall`,
        parameters: { onlyActive, idLanguage },
      };
    },
    getAmountByPK(idCampaign: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getAmountByPK`,
        parameters: { idCampaign },
      };
    },
    getByPk(idCampaign: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getbypk`,
        parameters: { idCampaign },
      };
    },
    save(campaign: ICampaign) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/save`,
        body: campaign,
      };
    },
    edit(campaign: ICampaign) {
      return {
        method: Method.PUT,
        relativeUrl: `${this.controller}/edit`,
        body: campaign,
      };
    },
    delete(idCampaign: number): IRequestOptions {
      return {
        method: Method.DELETE,
        relativeUrl: `${this.controller}/delete`,
        parameters: { idCampaign },
      };
    },
  };
  static promoter = {
    controller: 'promoter',
    getAll(onlyActive: boolean, idLanguage: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getall`,
        parameters: { onlyActive, idLanguage },
      };
    },
    getAmountByPK(idPromoter: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getAmountByPK`,
        parameters: { idPromoter },
      };
    },
    getByPk(idPromoter: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getbypk`,
        parameters: { idPromoter },
      };
    },
    save(promoter: IPromoter) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/save`,
        body: promoter,
      };
    },
    edit(promoter: IPromoter) {
      return {
        method: Method.PUT,
        relativeUrl: `${this.controller}/edit`,
        body: promoter,
      };
    },
    delete(idPromoter: number): IRequestOptions {
      return {
        method: Method.DELETE,
        relativeUrl: `${this.controller}/delete`,
        parameters: { idPromoter },
      };
    },
  };
  static message = {
    controller: 'message',
    startConversation(bodyParam: IStartConversation) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/startconversation`,
        body: bodyParam,
      };
    },
    makeOffer(bodyParam: MakeOfferDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/makeoffer`,
        body: bodyParam,
      };
    },
    sendMessage(bodyParam: IMessageDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/sendmessage`,
        body: bodyParam,
      };
    },
    getCountUnreadMessagesl() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getcountunreadmessages`,
      };
    },
    getAllMessages(idThread: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallmessages`,
        parameters: { idThread },
      };
    },
    getAllThreads(idLanguage: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallthreads`,
        parameters: { idLanguage },
      };
    },
    getRecipientByThread(idThread: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getrecipientuserbythread`,
        parameters: { idThread },
      };
    },
    getAllMessageToModerate(idLanguage: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallmessagetomoderate`,
        parameters: { idLanguage },
      };
    },
    moderateMessage(bodyParam: IModerateMessageDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/moderatemessage`,
        body: bodyParam,
      };
    },
    moderateTextMessage(bodyParam: IMessageUpdateDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/updatemessage`,
        body: bodyParam,
      };
    },
    getCountUnreadMessages() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getcountunreadmessages`,
      };
    },
    updateMessageRead(idMessageList: number[]): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/updatemessageread`,
        body: idMessageList,
      };
    },
    checkCanOffer(idAuction: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/checkcanoffer`,
        parameters: { idAuction },
      };
    },
  };
  static auction = {
    controller: 'auction',
    save(a: Auction) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/save`,
        body: a,
      };
    },
    getAll(iDLanguage: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getall`,
        parameters: { iDLanguage },
      };
    },
    getAllPublic(iDLanguage: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallpublicv2`,
        parameters: { iDLanguage },
      };
    },
    getAllSeller(iDLanguage: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallseller`,
        parameters: { iDLanguage },
      };
    },
    ConfirmPayment(body: ConfirmAuctionPaymentInput): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/confirmpayment`,
        body,
      };
    },
    getAllByEntity(iDLanguage: number, iDEntity: number, onlyApproved: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallbyentity`,
        parameters: { iDLanguage, iDEntity, onlyApproved },
      };
    },
    getByPk(idAuction: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getbypk`,
        parameters: { idAuction },
      };
    },
    getByPkV2(idAuction: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getbypkv2`,
        parameters: { idAuction },
      };
    },
    getAllTypes() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getalltypes`,
      };
    },
    delete(idAuction: number) {
      return {
        method: Method.DELETE,
        relativeUrl: `${this.controller}/delete`,
        parameters: { idAuction },
      };
    },
    edit(idAuction: number, body: AuctionDto) {
      return {
        method: Method.PATCH,
        relativeUrl: `${this.controller}/edit`,
        parameters: { idAuction: idAuction },
        body,
      };
    },
    bid(offer: BidDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/bid`,
        body: offer,
      };
    },
    buyNow(offer: BidDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/buynow`,
        body: offer,
      };
    },
    reserveBid(offer: AuctionReserveDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/reservebid `,
        body: offer,
      };
    },
    autoRebid(offer: UserAutoRebid) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/autorebid`,
        body: offer,
      };
    },
    deleteAutoRebid(idAutoRebid: number) {
      return {
        method: Method.DELETE,
        relativeUrl: `${this.controller}/deleteautorebid`,
        parameters: { idAutoRebid },
      };
    },
    deleteBid(idBid: number) {
      return {
        method: Method.DELETE,
        relativeUrl: `${this.controller}/deletebid`,
        parameters: { idBid },
      };
    },
    canmakebid(idAuction: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/canmakebid`,
        parameters: { idAuction },
      };
    },
    getAllForUserStarred(idLanguage: number): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallforuserstarred`,
        parameters: { idLanguage },
      };
    },
    getAllForUserWin(idLanguage: number): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallforuserwin`,
        parameters: { idLanguage },
      };
    },
    getAllForUserLost(idLanguage: number): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallforuserlost`,
        parameters: { idLanguage },
      };
    },
    getAllForUserToPay(idLanguage: number): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallforusertopay`,
        parameters: { idLanguage },
      };
    },
    getAllToPay(idLanguage: number): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getalltopay`,
        parameters: { idLanguage },
      };
    },
    getAuctionPriceInfo(idAuction: number): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getauctionpriceinfo`,
        parameters: { idAuction },
      };
    },
    getMinPriceForOffer(idAuction: number): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getminpriceforoffer`,
        parameters: { idAuction },
      };
    },
    setOfferResponse(offer: ResponseOfferDto): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/setofferresponse `,
        body: offer,
      };
    },
    proposeNewPrice(propose: ProposeNewPrice): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/proposenewprice `,
        body: propose,
      };
    },
    setSellerPayment(payment: AuctionSellerPaymentDto): IRequestOptions {
      return {
        method: Method.PUT,
        relativeUrl: `${this.controller}/setsellerpayment `,
        body: payment,
      };
    },
    getDefaultData(): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getdefaultdata`,
      };
    },
    getCurrentPrices(idAuctionList: number[]): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/get-current-prices`,
        body: idAuctionList,
      };
    },
  };
  static auctionpayment = {
    controller: 'auctionpayment',
    getCart(idLanguage: number): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getcart`,
        parameters: { idLanguage },
      };
    },
    addAccessory(auctionPaymentAccessoryDto: AuctionPaymentAccessoryDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/addaccessory`,
        body: auctionPaymentAccessoryDto,
      };
    },
    removeAccessory(
      idAuctionPaymentAccessory: number,
      idLanguage: number,
      guidPayment: string
    ): IRequestOptions {
      return {
        method: Method.DELETE,
        relativeUrl: `${this.controller}/removeaccessory`,
        parameters: { idAuctionPaymentAccessory, idLanguage, guidPayment },
      };
    },
    saveShippingAddress(shippingAddress: AuctionPaymentsAddressDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/saveshippingaddress`,
        body: shippingAddress,
      };
    },
    saveBillingAddress(billingAddress: AuctionPaymentsAddressDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/savebillingaddress`,
        body: billingAddress,
      };
    },
    CheckCartRequirments(): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/checkcartrequirments`,
      };
    },
    CreatePaymentSession(body: CreatePaymentSessionDto): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/createpaymentsession`,
        body,
      };
    },
    CreatePaymentIntent(body: CreatePaymentSessionDto): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/createpaymentintent`,
        body,
      };
    },
    ConfirmPaymentIntent(body: StripePaymentIntentConfirmDto): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/stripeintentsuccess`,
        parameters: body,
      };
    },
    CapturePayment(body: CapturePaypalPaymentDto): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/capturepaypal`,
        parameters: body,
      };
    },
    BankTransferConfirm(body: PaymentGuidDto): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/banktransferconfirm`,
        body,
      };
    },
    GetBankData(body: CreatePaymentSessionDto): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/getbankdata`,
        body,
      };
    },
    ConfirmPayment(body: ConfirmAuctionPaymentInput): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/confirmpayment`,
        body,
      };
    },
    // Multiseller payment endpoints
    getSellersToPayGrouped(idLanguage: number): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getsellerstopaygrouped`,
        parameters: { idLanguage },
      };
    },
    getAuctionsBySeller(
      idLanguage: number,
      idEntitySeller: number
    ): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getauctionsbyseller`,
        parameters: { idLanguage, idEntitySeller },
      };
    },
    getCartBySeller(
      idLanguage: number,
      idEntitySeller: number,
      guidPayment: string
    ): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getcartbyseller`,
        parameters: { idLanguage, idEntitySeller, guidPayment },
      };
    },
    setSameAddresses(request: {
      sameAddresses: boolean;
      guidPayment: string;
    }): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/setsameaddresses`,
        body: request,
      };
    },
    getBankMoneyTransfert(guidPayment: string): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getbankmoneytransfert`,
        parameters: { guidPayment },
      };
    },
    getPaymentMethodsForSeller(idEntitySeller: number): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/get-payment-methods-for-seller/${idEntitySeller}`,
      };
    },
  };
  static shippingconfiguration = {
    controller: 'shippingconfiguration',
    getAllCouriers() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallcouriers`,
      };
    },
    getAllShippingRate(idCourier: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallshippingrate`,
        parameters: { idCourier },
      };
    },
    insertShippingRate(rate: ShippingRateDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/insertshippingrate`,
        body: rate,
      };
    },
    updateShippingRate(rate: ShippingRateDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/updateshippingrate`,
        body: rate,
      };
    },
    getAllShippingRateCountry(idShippingRate: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallshippingratecountry`,
        parameters: { idShippingRate },
      };
    },
    insertShippingRateCountry(country: ShippingRateCountryDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/insertshippingratecountry`,
        body: country,
      };
    },
    updateShippingRateCountry(country: ShippingRateCountryDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/updateshippingratecountry`,
        body: country,
      };
    },
    deleteShippingRateCountry(country: ShippingRateCountryDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/deleteshippingratecountry`,
        body: country,
      };
    },
    validateShippingAvailability(idArticle: number): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/validate-shipping/${idArticle}`,
      };
    },
    getUserShippingAddresses(): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/user-shipping-addresses`,
      };
    },
  };
  static insurance = {
    controller: 'insurance',
    getAll() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getall`,
      };
    },
    save(body: Insurance): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/save`,
        body,
      };
    },
    getByPk(idInsurance: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getbypk`,
        parameters: { idInsurance },
      };
    },
    delete(idInsurance: number): IRequestOptions {
      return {
        method: Method.DELETE,
        relativeUrl: `${this.controller}/delete`,
        parameters: { idInsurance },
      };
    },
  };
  static certificate = {
    controller: 'certificate',
    getAll() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getall`,
      };
    },
    /*getByCode(certificateCode: string) {
        return {
            method: Method.GET,
            relativeUrl: `${this.controller}/getByCode`,
            parameters: { certificateCode }
        }
    },
    save(c: ICertificate) {
        return {
            method: Method.POST,
            relativeUrl: `${this.controller}/save`,
            body: c
        }
    }*/
  };
  static article = {
    controller: 'article',
    getTypes() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/gettypes`,
      };
    },
    getAllCertificateTypes() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallcertificatetypes`,
      };
    },
    getProperties(iDArticleType: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getproperties`,
        parameters: { iDArticleType },
      };
    },
    getArticleByCertificate(certificate: string) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getarticlebycertificate`,
        parameters: { certificate },
      };
    },
  };
  static starredarticle = {
    controller: 'starredarticle',
    save(item: ArticleRequest) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/save`,
        body: item,
      };
    },
    delete(item: ArticleRequest) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/delete`,
        body: item,
      };
    },
    getAll() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}`,
      };
    },
  };
  static slideShow = {
    controller: 'slideshow',
    getSlideShowItemByPK(idItem: number): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getbypk`,
        parameters: { idItem },
      };
    },
    getSlideShowItems(
      onlyActive: boolean,
      idLanguage: number
    ): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getall`,
        parameters: { onlyActive, idLanguage },
      };
    },
    save(item: ISlideShowItem) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/save`,
        body: item,
      };
    },
    edit(item: ISlideShowItem) {
      return {
        method: Method.PUT,
        relativeUrl: `${this.controller}/edit`,
        body: item,
      };
    },
    delete(iDItem: number): IRequestOptions {
      return {
        method: Method.DELETE,
        relativeUrl: `${this.controller}/delete`,
        parameters: { iDItem },
      };
    },
  };

  static auctionView = {
    controller: 'auctionView',
    getAll(filters: IAuctionFilterDto): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/getall`,
        body: filters,
      };
    },
    getAllV2(filters: IAuctionFilterDto): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/getallv2`,
        body: filters,
      };
    },
    getSuggested(idLanguage: number, idAuction: number): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/get-suggested/${idLanguage}/${idAuction}`,
      };
    },
    getAllAndCountV1(filters: IAuctionFilterDto): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/getallandcount`,
        body: filters,
      };
    },
    getAllAndCountV2(filters: IAuctionFilterDto): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/getallandcountv2`,
        body: filters,
      };
    },
    getByPk(idAuction: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getbypk`,
        parameters: { idAuction },
      };
    },
    getByPkV2(idAuction: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getbypkv2`,
        parameters: { idAuction },
      };
    },
    getHistory(idAuction: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/gethistory`,
        parameters: { idAuction },
      };
    },
    getReserve(idAuction: number, idUser: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getreserve`,
        parameters: { idAuction, idUser },
      };
    },
  };

  static readonly categories = {
    controller: 'categories',
    getAll() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/`,
      };
    },
    getRelatedTagCategories(idTag: number, onlyActive: boolean) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/related/by-tag/${idTag}`,
        parameters: { onlyActive },
      };
    },
    getRelatedTagSellerCategories(
      idTag: number,
      idSeller: number,
      onlyActive: boolean
    ) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/related/by-tag-and-seller/${idTag}/${idSeller}`,
        parameters: { onlyActive },
      };
    },
  };

  static filter = {
    controller: 'filter',
    getAllTypes(): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getalltypes`,
      };
    },
    getAllFilterProperties(idArticleType: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallfilterproperties`,
        parameters: { idArticleType },
      };
    },
    getFilterPropertyValue(itemOrder: number, value: string) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallfilterpropertiesvalues`,
        parameters: { itemOrder, value },
      };
    },
    getAllProperties(
      filterProperties: GetAllFilterPropertiesDto
    ): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/getallproperties`,
        body: filterProperties,
      };
    },
  };

  static settings = {
    controller: 'GlobalSettings',
    getSettings(): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getSettings`,
        parameters: {},
      };
    },
    save(s: ISettings): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/save`,
        body: s,
      };
    },
  };

  static translation = {
    controller: 'Translation',
    getAllLanguages(): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getalllanguages`,
        parameters: {},
      };
    },
    getAllIds(): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallids`,
        parameters: {},
      };
    },
    getallForAdmin(): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallforadmin`,
        parameters: {},
      };
    },
    saveTranslation(param: ITranslationDto[]): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/savetranslation`,
        body: param,
      };
    },
  };

  static getTranslations(langCode: string) {
    return {
      method: Method.GET,
      relativeUrl: 'translation/getall',
      parameters: { langCode },
    };
  }

  static getTranslationsAfter(langCode: string, timestamp: number) {
    return {
      method: Method.GET,
      relativeUrl: `translation/${langCode}/${timestamp}`,
    };
  }

  static pagetext = {
    controller: 'pagetext',
    getPagesName() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getpagesname`,
      };
    },
    getByPk(idPage: number, idLanguage: number): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getbypk`,
        parameters: { idPage, idLanguage },
      };
    },
    getGroups(): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getgroups`,
      };
    },
    save(pt: PageText) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/save`,
        body: pt,
      };
    },
  };

  static customUrl = {
    controller: 'customurl',
    getCampaignsKeyValue(iDLanguage: number): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getcampaignskeyvalue`,
        parameters: { iDLanguage },
      };
    },
    getPromotersKeyValue(iDLanguage: number): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getpromoterskeyvalue`,
        parameters: { iDLanguage },
      };
    },
    getAuctionsKeyValue(iDLanguage: number): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getauctionskeyvalue`,
        parameters: { iDLanguage },
      };
    },
    save(body: ICustomUrlDto): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/save`,
        body,
      };
    },
    delete(idCustomUrl: number): IRequestOptions {
      return {
        method: Method.DELETE,
        relativeUrl: `${this.controller}/delete`,
        parameters: { idCustomUrl },
      };
    },
    getAll(): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getall`,
      };
    },
    getByUrl(url: string): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getbyurl`,
        parameters: { url },
      };
    },
    getByPk(iDCustomUrl: number): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getbypk`,
        parameters: { iDCustomUrl },
      };
    },
  };

  static notification = {
    controller: 'notification',
    getNotifications(idLanguage: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getnotifications`,
        parameters: { idLanguage },
      };
    },
    getUnreadNotificationsCount() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getunreadnotificationscount`,
      };
    },
    confirmNotification(
      confirmNotification: IConfirmNotification
    ): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/confirmnotification`,
        body: confirmNotification,
      };
    },
  };

  static memorabidevent = {
    controller: 'memorabidevent',
    getAll() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getall`,
      };
    },
    getByPk(idEvent: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getbypk`,
        parameters: { idEvent },
      };
    },
    getBySlug(slug: string, loadOnlyVisible: boolean) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getbyslug`,
        parameters: { slug, loadOnlyVisible },
      };
    },
    getAllViewByPk(idEvent: number, idLanguage: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallviewbypk`,
        parameters: { idEvent, idLanguage },
      };
    },
    getAllViewBySlug(slug: string, idLanguage: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getallviewbyslug`,
        parameters: { slug, idLanguage },
      };
    },
    save(memoraEventSaveDto: MemoraEventSaveDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/save`,
        body: memoraEventSaveDto,
      };
    },
    getSummary(idEvent: number, idLanguage: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getsummary`,
        parameters: { idEvent, idLanguage },
      };
    },
    getEventNotification(idEvent: number, idLanguage: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/geteventnotification`,
        parameters: { idEvent, idLanguage },
      };
    },
    getTotalAmount(idEvent: number): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/gettotalamount`,
        parameters: { idEvent },
      };
    },
    getEventDateEnd(idEvent: number): IRequestOptions {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/geteventdateend`,
        parameters: { idEvent },
      };
    },
    bid(offer: BidDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/bid`,
        body: offer,
      };
    },
    autoRebid(offer: UserAutoRebid) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/autorebid`,
        body: offer,
      };
    },
    setNotificationStatus(status: NotificationStatusDto): IRequestOptions {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/setnotificationstatus`,
        body: status,
      };
    },
  };

  static donation = {
    controller: 'donation',
    save(donation: DonationDto) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/save`,
        body: donation,
      };
    },
  };

  static charity = {
    controller: 'charity',
    getAll() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getall`,
      };
    },
    getByPk(idCharity: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getbypk`,
        parameters: { idCharity },
      };
    },
    save(charity: ICharity) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/save`,
        body: charity,
      };
    },
    delete(idCharity: number): IRequestOptions {
      return {
        method: Method.DELETE,
        relativeUrl: `${this.controller}/delete`,
        parameters: { idCharity },
      };
    },
  };

  static sponsor = {
    controller: 'sponsor',
    getAll() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getall`,
      };
    },
    getByPk(idSponsor: number) {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/getbypk`,
        parameters: { idSponsor },
      };
    },
    save(sponsor: ISponsor) {
      return {
        method: Method.POST,
        relativeUrl: `${this.controller}/save`,
        body: sponsor,
      };
    },
    delete(idSponsor: number): IRequestOptions {
      return {
        method: Method.DELETE,
        relativeUrl: `${this.controller}/delete`,
        parameters: { idSponsor },
      };
    },
  };
  static sitemap = {
    controller: 'sitemap',
    createSitemap() {
      return {
        method: Method.GET,
        relativeUrl: `${this.controller}/createsitemap`,
      };
    },
  };
}

export class ApiHolderUtils {

}
